import { type ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { SidebarToggle } from './SidebarToggle'
import { useSearchParams } from 'react-router-dom'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  
  const [searchParams] = useSearchParams();
  const menu = searchParams.get("menu");   // "0"

  return (
    <div className="d-flex dashboard">

      {
        menu === "0" ? 
        <></> : 
          <>
            <Sidebar position="left" />
            <SidebarToggle />
          </>
      }
      



      <div className="content">
          {/* Header - 10% height <Header /> */ }


            {/* Main Content */}
            <span className="content">
              <span className="udsp_default">
                {/*<div pantalla="CONTENIDO">*/}
                {children}
              </span>

            </span>
      </div>

    </div>
  )
}